const fetchPictureMarkerOption = (markPictureOption, imgIdList) => {
  return markPictureOption.map((element, index) => {
    const option = {
      parentNode: element?.parentNode || null,
      pos: element?.pos || [0, 0, 0], // 定位点，世界坐标，三维向量
      visible: element?.visible || true, // 显示隐藏状态
      size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
      nodeOffset: element.nodeOffset,
      imgId: imgIdList[index], // 图片
      imgSize: element.imgSize, // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
      text: '', // 文本
      fontSize: 14.0, // 字体大小
      breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
      contentPadding: [10, 10, 10, 10], // 文字相对标记的偏移量
      textColor: -1, // 文本颜色
      title: '', // 标题
      titleFontSize: 18.0, // 标题文字大小
      titleColor: 0xffffffff, // 标题颜色
      userData: null, // 用户数据，仅帮外部系统保存数据
    }
    if (element.LodRange && element.LodRange.length > 2) {
      option.minLod = element.LodRange[0]
      option.maxLod = element.LodRange[1]
    }
    if (option.parentNode) delete option.pos
    return option
  })
}
// 图片标签
const createByPicture = async (player, markPictureOption) => {
  if (!player || !player.Native) {
    // 加载失败
    return {
      status: false,
      message: 'player无效',
      data: [],
    }
  }
  if (!Array.isArray(markPictureOption)) {
    markPictureOption = [markPictureOption]
  }
  // 获取需要加载标签的列表
  const imgList = markPictureOption.map((element) => {
    return element.backgroundUrl
  })

  const imgIdList = await player.Native?.GisMarker.loadImages(imgList)
  // 批量加载标签
  const optionList = fetchPictureMarkerOption(markPictureOption, imgIdList)
  const optionsPtr = await player.Native?.GisMarker.batchCreate(optionList)
  const currentLoadMarkers = []
  currentLoadMarkers.push(
    ...optionsPtr.map((el, index) => {
      return {
        id: markPictureOption[index].id,
        pointer: el,
      }
    })
  )
  return {
    status: true,
    message: '加载成功',
    data: currentLoadMarkers,
  }
}
export { createByPicture }
